/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SurveySummary = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        resident: {
    type: 'string',
    isRequired: true,
},
        room: {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
        physician: {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
        data: {
    type: 'array',
    contains: {
        type: 'ResponseSurveyData',
    },
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
},
    },
};